export default {
  Language: "English",
  navbar: {
    homeFormat: "Home",
    warehouseFormat: "Warehouse",
    wineFormat: "Wine",
    contactFormat: "Contact us",
    sellwinesFormat: "Sell your wines",
  },
  home: {
    swiperTextFormat: "All you need to do is taste it carefully!",
    swiperTextFormat2: "Looking for wine,",
    swiperTextFormat3: " Just leave it to us!",
    swiperBtnFormat: "Delicious wine",
    contactModel: {
      titleFormat: "About us",
      contentFormat:
        "We are a group of like-minded people who love drinking and are passionate about leisure life. We enjoy searching for our favorite alcoholic beverages on our own. So, we began to provide our fellow drinkers with diverse and excellent services to our consumers, and thus LeapflyWine was born.",
      contentFormat2:
        "When you finish your busy work and want to reward yourself with a drink before bedtime or after dinner. At this point, all you need to do is take out a bottle of LeapflyWine from the freezer, which will definitely satisfy your taste buds and preferences.",
      btnFormat: "Learn more",
    },
    teamModel: {
      titleFormat: "Excellent team",
      contentFormat:
        "Our team has rich practical experience and values customer needs more. Our ideal is to conquer customers' taste buds with excellent quality.",
    },
    exclusiveModel: {
      titleFormat: "Exclusive Advisor",
      contentFormat:
        "We know that each customer has different preferences for alcoholic beverages, and when you make a purchase, we will record your favorite drinks and provide you with suggestions. If you have any questions, please feel free to contact us via email during working hours. We will hire a dedicated consultant team to serve you.",
				contentFormat2:
        "Our consulting team will provide you with basic concepts for preserving wine and a guide for purchasing wine items, quickly establishing the necessary basic concepts to assist you in enjoying the wine tasting process more.",
			},
  },
  wines: {
    inputplaceholder1: "Please enter the content",
    inputplaceholder2: "Price starting range",
    inputplaceholder3: "Price End Range",
    allIn: "AllIn",
    filterOptions: {
      yearFormat: "Year",
      countryFormat: "Country",
      areaFormat: "Production area",
      specificationsFormat: "Specifications",
      typeFormat: "Type",
    },
    tableFormat: {
      chFormat: "Chinese name",
      enFormat: "English name",
      yearFormat: "Year",
      typeFormat: "Type",
      specificationsFormat: "Specifications",
      countryFormat: "Country",
      areaFormat: "Production area",
      priceFormat: "Price",
    },
  },
  contact: {
    contactFromFormat: {
      titleFormat: "Contact us",
      contentFormat:
        "We attach great importance to your opinions. If you have any questions, please fill in the following information and we will contact you soon.",
    },
    mapTitleFormat: "A beautiful time accompanied by wine",
    mapTextFormat: `Company Profile: Lifa Trading Co., Ltd. is located in Macau, China. Founded in 2021, it is a well-known liquor enterprise specializing in imported wine. Our founders are a group of industry veterans who love wine. They have been working in the wine industry for many years and have met numerous representatives of high-quality wineries and industry elites. Our products are guaranteed to have excellent quality, and most of them are purchased directly from their place of origin to maintain their original flavor; The remaining products are provided by industry partners. We are known for our warm and thoughtful service, always adhering to a serious and responsible attitude, and doing our best to solve problems for customers and partners, ensuring their satisfaction. The company adheres to the business philosophy of "honest operation, mutual benefit and win-win", constantly optimizes the business system, promotes innovative development, and fully exploits the huge potential of online sales on the Internet.`,
    formFormat: {
      nameFormat: "Full name",
      namePlaceholder: "Please enter your name",
      namePassed: "Name entered correctly",
      phoneFormat: "Phone",
      phonePlaceholder: "Please enter phone number",
      phonePassed: "Phone input is correct",
      emailFormat: "Email",
      emailPlaceholder: "Please enter your email address",
      emailPassed: "Email input is correct",
      contentFormat: "Content",
      contentPlaceholder: "If you have any questions about alcoholic beverages, please leave a message and let us know",
      contentPassed: "Comments have been entered",
      privacyMsg: "I agree to the privacy policy and agree to process my data in the manner described in the privacy policy",
      privacyMsgPlaceholder: "Privacy is required",
      privacyPassed: "Selected",
    },
    submitFormat: {
      btnFormat: "Confirm to send out",
    },
  },
  sellwines: {
    sellwinesFromFormat: {
      titleFormat: "Send us your list",
      contentFormat:
        "As a major shareholder, LeapflyWine is always enthusiastic about purchasing well stored private collections, whether it is paying customs duties in private wine cellars or bonded in professional warehouses. After receiving the wine list, we are happy to provide purchase quotes for each wine and make payment immediately upon receipt and inspection of the wine according to the agreement. Your wine list can be uploaded through the link on this page or sent directly to us via email",
    },
    formFormat: {
      nameFormat: "Full name",
      namePlaceholder: "Please enter your name",
      namePassed: "Name entered correctly",
      phoneFormat: "Phone",
      phonePlaceholder: "Please enter phone number",
      phonePassed: "Phone input is correct",
      emailFormat: "Email",
      emailPlaceholder: "Please enter your email address",
      emailPassed: "Email input is correct",
      contentFormat: "Regarding your wine",
      contentPlaceholder: "Tell us about your wine",
      contentPassed: "Comments have been entered",
      privacyMsg: "I agree to the privacy policy and agree to process my data in the manner described in the privacy policy",
      privacyMsgPlaceholder: "Privacy is required",
      privacyPassed: "Selected",
      uploadMsg: "Upload your wine list * Upload your existing Excel list to get started.",
    },
    submitFormat: {
      uploadBtnFormat: "Upload",
      btnFormat: "Confirm to send out",
    },
  },
	warehouse: {
    titleFormat: "A wonderful time accompanied by fine wine",
    contentFormat: ` In August 2020, LeapflyWine opened its first online store。`,
		contentFormat2: `The establishment of LeapflyWine injects more diversified colors into consumers and purchases foreign wines from more than 20 countries to provide to our consumers.`,
		contentFormat3: `LeapflyWine's warehouses are equipped with 24-hour constant temperature and humidity control to ensure that all table wines are properly stored before being handed over to customers.`,
		contentFormat4: `Members of LeapflyWine are required to complete internationally recognized Wine&Spirit Education Trust courses, Enable them to grasp the background information and characteristics of various alcoholic beverages, in order to introduce them to guests`,
	},
  footer: {
    contactFormat: {
      titleFormat: "Contact us",
    },
    addressFormat: {
      titleFormat: "Address",
      addressInFormat: "Lifa Trading Co., Ltd",
      addressInFormat2: "Unit S, 14th Floor, 762-804 Avenida da Marina, Macau",
      icpFormat: "ICP record number: Guangdong ICP No. 2022091707",
    },
  },
};
